import { render } from "./Results.vue?vue&type=template&id=c47b1c72&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=c47b1c72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47b1c72"],['__file',"src/apps/quiz/routes/Results.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c47b1c72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c47b1c72', __exports__)) {
    api.reload('c47b1c72', __exports__)
  }
  
  module.hot.accept("./Results.vue?vue&type=template&id=c47b1c72&scoped=true", () => {
    api.rerender('c47b1c72', render)
  })

}


export default __exports__